import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-regular-svg-icons';
import classnames from 'classnames';
import c from './CalendarGrid.module.scss';

/**
 * @param {Object} props
 * @param {string} props.title Section heading displayed in the toggle.
 * @param {React.ReactNode} props.children Collapsible section content.
 * @returns {React.ReactElement}
 */
const SettingsSection = ({ title, children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className={c.section}>
      <button
        type="button"
        className={c.sectionButton}
        aria-expanded={isOpen}
        onClick={() => setIsOpen((open) => !open)}
      >
        <span>{title}</span>
        <FontAwesomeIcon.Memo icon={faChevronDown} className={classnames(c.chevron, isOpen && c.chevronOpen)} />
      </button>
      {isOpen ? <div className={c.sectionContent}>{children}</div> : null}
    </section>
  );
};

export default SettingsSection;
